define("settings/components/groups/group/members/table/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <table class="o--table o--table--hover tAC--table qa--settings__usersTable">
    <thead>
      <tr>
        <th class="u--text--left">
          {{t "shared_words.name"}}
        </th>
        <th class="u--text--left">
          {{t "shared_words.email"}}
        </th>
        <th class="u--text--left qa--settings_user_roles">
          {{t "shared_words.roles"}}
          <Shared::Ui::Button @onClick={{toggle-action "showUserRolesModal" this}} @variant="unstyled">
            {{svg-jar "info" class="o--icon--sm qa--settings_user_roles_icon"}}
          </Shared::Ui::Button>
        </th>
        <th class="u--text--left">
          {{t "shared_words.actions"}}
        </th>
      </tr>
    </thead>
    <tbody>
      {{#each this.group.sortedNonContributorsMembersUserRoles as |member|}}
        <tr class="u--text--md">
          <td class="dd-privacy-mask-user-input">
            {{member.user.name}}
          </td>
          <td class="dd-privacy-mask-user-input">
            {{member.user.email}}
          </td>
          <td>
            {{#if member.isAccountOwner}}
              <span class="tAC--section__pill">{{t "shared_words.account_owner"}}</span>
            {{/if}}
            {{#if member.needsApproval}}
              <span class="tAC--section__pill">{{t "shared_words.member_restricted"}}</span>
            {{else}}
              <span class="tAC--section__pill">{{t "shared_words.member"}}</span>
            {{/if}}
            {{#if member.isApprover}}
              <span class="tAC--section__pill">{{t "shared_words.reviewer"}}</span>
            {{/if}}
          </td>
          <td class="u--text--center">
            {{#unless member.isAccountOwner}}
              <Shared::Ui::Button
                @onClick={{fn this.redirectToEditRoute member.user.id}}
                @text={{t "shared_words.edit"}}
                @variant="outline"
                aria-label={{t "shared_words.edit"}}
                class="qa--settings_user_roles_editBtn"
              />
              <Shared::Ui::Button
                @onClick={{perform this.deleteMember member.user.content}}
                @text={{t "shared_words.remove"}}
                @variant="unstyled"
                aria-label={{t "shared_words.remove"}}
                class="o--btn o--btn--mute qa--settings_user_roles_removeBtn"
              />
            {{/unless}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
  
  {{#if this.showUserRolesModal}}
    <Groups::Group::Members::UserRoleModal @closeModal={{toggle-action "showUserRolesModal" this}} />
  {{/if}}
  {{#if this.showApprovalFlowUpgradeModal}}
    <Groups::Group::Members::ApprovalFlowUpgradeModal
      @closeModal={{toggle-action "showApprovalFlowUpgradeModal" this}}
      @learnMoreLink={{this.learnMoreLink}}
    />
  {{/if}}
  */
  {
    "id": "8odNnVH7",
    "block": "[[[10,\"table\"],[14,0,\"o--table o--table--hover tAC--table qa--settings__usersTable\"],[12],[1,\"\\n  \"],[10,\"thead\"],[12],[1,\"\\n    \"],[10,\"tr\"],[12],[1,\"\\n      \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"shared_words.name\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"shared_words.email\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[14,0,\"u--text--left qa--settings_user_roles\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"shared_words.roles\"],null]],[1,\"\\n        \"],[8,[39,1],null,[[\"@onClick\",\"@variant\"],[[28,[37,2],[\"showUserRolesModal\",[30,0]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon--sm qa--settings_user_roles_icon\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"shared_words.actions\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"group\",\"sortedNonContributorsMembersUserRoles\"]]],null]],null],null,[[[1,\"      \"],[10,\"tr\"],[14,0,\"u--text--md\"],[12],[1,\"\\n        \"],[10,\"td\"],[14,0,\"dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[1,[30,1,[\"user\",\"name\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[14,0,\"dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[1,[30,1,[\"user\",\"email\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,1,[\"isAccountOwner\"]],[[[1,\"            \"],[10,1],[14,0,\"tAC--section__pill\"],[12],[1,[28,[35,0],[\"shared_words.account_owner\"],null]],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"needsApproval\"]],[[[1,\"            \"],[10,1],[14,0,\"tAC--section__pill\"],[12],[1,[28,[35,0],[\"shared_words.member_restricted\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,1],[14,0,\"tAC--section__pill\"],[12],[1,[28,[35,0],[\"shared_words.member\"],null]],[13],[1,\"\\n\"]],[]]],[41,[30,1,[\"isApprover\"]],[[[1,\"            \"],[10,1],[14,0,\"tAC--section__pill\"],[12],[1,[28,[35,0],[\"shared_words.reviewer\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,\"td\"],[14,0,\"u--text--center\"],[12],[1,\"\\n\"],[41,[51,[30,1,[\"isAccountOwner\"]]],[[[1,\"            \"],[8,[39,1],[[16,\"aria-label\",[28,[37,0],[\"shared_words.edit\"],null]],[24,0,\"qa--settings_user_roles_editBtn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,8],[[30,0,[\"redirectToEditRoute\"]],[30,1,[\"user\",\"id\"]]],null],[28,[37,0],[\"shared_words.edit\"],null],\"outline\"]],null],[1,\"\\n            \"],[8,[39,1],[[16,\"aria-label\",[28,[37,0],[\"shared_words.remove\"],null]],[24,0,\"o--btn o--btn--mute qa--settings_user_roles_removeBtn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,9],[[30,0,[\"deleteMember\"]],[30,1,[\"user\",\"content\"]]],null],[28,[37,0],[\"shared_words.remove\"],null],\"unstyled\"]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showUserRolesModal\"]],[[[1,\"  \"],[8,[39,10],null,[[\"@closeModal\"],[[28,[37,2],[\"showUserRolesModal\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showApprovalFlowUpgradeModal\"]],[[[1,\"  \"],[8,[39,11],null,[[\"@closeModal\",\"@learnMoreLink\"],[[28,[37,2],[\"showApprovalFlowUpgradeModal\",[30,0]],null],[30,0,[\"learnMoreLink\"]]]],null],[1,\"\\n\"]],[]],null]],[\"member\"],false,[\"t\",\"shared/ui/button\",\"toggle-action\",\"svg-jar\",\"each\",\"-track-array\",\"if\",\"unless\",\"fn\",\"perform\",\"groups/group/members/user-role-modal\",\"groups/group/members/approval-flow-upgrade-modal\"]]",
    "moduleName": "settings/components/groups/group/members/table/index.hbs",
    "isStrictMode": false
  });
  let TableComponent = _exports.default = (_class = class TableComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "settings", _descriptor5, this);
      _initializerDefineProperty(this, "router", _descriptor6, this);
      _initializerDefineProperty(this, "segment", _descriptor7, this);
      _initializerDefineProperty(this, "showUserRolesModal", _descriptor8, this);
      _initializerDefineProperty(this, "showApprovalFlowUpgradeModal", _descriptor9, this);
      _defineProperty(this, "deleteMember", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (member) {
          const membership = member.membershipFor(this.group);
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('account.groups.group.users.remove.confirm_title'), {
            description: this.intl.t('account.groups.group.users.remove.confirm', {
              email: member.email,
              group: this.group.name
            }),
            confirmButton: this.intl.t('shared_words.remove')
          });
          if (!didConfirm) {
            return;
          }
          try {
            const alert = yield this.settings.submitForm.perform(membership.destroyRecord(), 'account.groups.group.users.remove', {
              email: member.email,
              group: this.group.name
            });
            if (alert?.alert) {
              this.alerts.add(alert.alert);
            }
            this.group.get('members').removeObject(member);
            this.segment.track('removed-user-from-group', {
              group_name: this.group.name,
              user_email: member.email
            });
          } catch ({
            alert
          }) {
            this.alerts.add(alert);
          }
        }
      }), null, "deleteMember", "drop"));
    }
    get canApprovalFlow() {
      return Boolean(this.auth.currentAccount.canApprovalFlow);
    }
    get group() {
      return this.args.group;
    }
    redirectToEditRoute(userId) {
      if (this.canApprovalFlow) {
        this.router.transitionTo('account.groups.group.members.edit', this.group.id, userId);
      } else {
        this.showApprovalFlowUpgradeModal = true;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showUserRolesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "showApprovalFlowUpgradeModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "redirectToEditRoute", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "redirectToEditRoute"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TableComponent);
});